/**
 * Created by olga on 26.10.2022
 */

const TextHintContent = function (options) {
    this.message = options.message;
};

TextHintContent.isApplicable = function (options) {
    return options.message !== undefined;
};

TextHintContent.prototype.hasSameContent = function (options) {
    if (!options.message) {
        return false;
    }
    return this.message === options.message;
};

TextHintContent.prototype.getMessages = function () {
    if (Array.isArray(this.message)) {
        return this.message;
    }
    return [
        { text: this.message, align: true }
    ];
};